import { Popup, Button } from "@oxygen/core";
import { closeSubscriptionPopup } from "GlobalActionCreator/SubscriptionPopup";
import { platform } from "GlobalEnum/Platform";
import { subscriptionPopup } from "GlobalReducer/SubscriptionPopup";
import { ClientOnly } from "GlobalUtils/ClientOnly";
import { withReducers } from "GlobalUtils/ReducerManager";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KeepMeInformed } from "SrcPath/Model/components/KeepMeInformed";
import getThemeClasses from "@oxygen/theme";

const textClasses = getThemeClasses(`
  font-size-6.5 md:font-size-7.5;
  color-dimGray;
  mb-5;
`);
const getPrimaryTitle = isThankYouScreenActive => {
  return isThankYouScreenActive ? "Thank You!" : "Notify me";
};
const getCrossIconOffset = isThankYouScreenActive => {
  return isThankYouScreenActive ? "cross" : "crossOffset";
};
const getHeaderColor = isThankYouScreenActive => {
  return isThankYouScreenActive ? "teal" : "white";
};
const containerClasses = getThemeClasses(`
  m-10;
`);
const getThankYouMessage = (response, makeName, modelName) => {
  return response
    ? `We will notify you when ${makeName} ${modelName} gets launched`
    : `You are already subscribed`;
};
function SubscriptionPopup(props) {
  const { isActive, modelId, makeName, modelName } = useSelector(
    state => state.subscriptionPopup || {}
  );
  const [isThankYouScreenActive, setIsThankYouScreenActive] = useState(false);
  const [subMessage, setSubMessage] = useState("");
  const dispatch = useDispatch();
  const handleCrossButtonClick = () => {
    setIsThankYouScreenActive(false);
    dispatch(closeSubscriptionPopup());
  };
  const isPopupActive = isActive || isThankYouScreenActive;
  const handleSubscribeButtonClick = response => {
    dispatch(closeSubscriptionPopup());
    setSubMessage(getThankYouMessage(response, makeName, modelName));
    setIsThankYouScreenActive(true);
  };

  let popupProps = {};
  const { platformId } = props;
  if (platformId === platform.DESKTOP.id) {
    popupProps = {
      direction: "center",
      widthClassName: "auto",
    };
  }
  return (
    <ClientOnly>
      <Popup
        heightClassName="auto"
        roundedCornersOnDevice="all"
        headerColorVariant={getHeaderColor(isThankYouScreenActive)}
        closableIcon={getCrossIconOffset(isThankYouScreenActive)}
        isActive={isPopupActive}
        primaryTitle={getPrimaryTitle(isThankYouScreenActive)}
        handleClose={handleCrossButtonClick}
        {...popupProps}
      >
        {!isThankYouScreenActive && (
          <KeepMeInformed
            modelId={modelId}
            isWrappedInPopup
            onSubmit={handleSubscribeButtonClick}
          />
        )}
        {isThankYouScreenActive && (
          <div className={containerClasses}>
            <div className={textClasses}>{subMessage}</div>
            <Button
              block
              onClick={handleCrossButtonClick}
              data-testing-id="done"
            >
              Done
            </Button>
          </div>
        )}
      </Popup>
    </ClientOnly>
  );
}

export default withReducers({ subscriptionPopup })(SubscriptionPopup);
